function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 1.6875,
  y: 0.9375,
  width: 5.925,
  height: 2.325,
  stroke: "#E85558",
  strokeWidth: 1.875
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 11.8877,
  y: 0.9375,
  width: 5.925,
  height: 7.125,
  stroke: "#E85558",
  strokeWidth: 1.875
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 11.8877,
  y: 12.3374,
  width: 5.925,
  height: 4.725,
  stroke: "#E85558",
  strokeWidth: 1.875
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 1.6875,
  y: 7.5376,
  width: 5.925,
  height: 9.525,
  stroke: "#E85558",
  strokeWidth: 1.875
});

var SvgDashboardSubitemIcon = function SvgDashboardSubitemIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboardSubitemIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard-subitem-icon.5d53d49e.svg";
export { ForwardRef as ReactComponent };